import React, { useEffect, useState } from 'react'
import { Dropdown } from 'antd'
import classNames from 'classnames'
import Icon from '../../component/icon'
import './index.less'

export default (props) => {
  const {
    onChange,
    trigger,
    placement,
    overlayStyle,
    overlayClassName,
    style,
    className,
    onlyValue,
    isActiveStyle,
    displayOverlay,
    ...otherProps
  } = props
  const [visible, setVisible] = useState(false)
  const _onChange = (val) => {
    onChange?.(val)
    setVisible(false)
  }
  let displayStyle = {}
  if (displayOverlay === 'left') {
    displayStyle = {
      position: 'absolute',
      right: 0,
    }
  }
  const dropdownOverlayStyle = {
    width: 'auto',
    minWidth: 0,
    maxWidth: 'none',
    ...overlayStyle,
  }
  return <Dropdown
    overlayStyle={dropdownOverlayStyle}
    overlayClassName={classNames('report-cascade-dropdown', overlayClassName)}
    trigger={trigger}
    overlay={onlyValue ? <ListOnlyValue
      displayStyle={displayStyle}
      displayOverlay={displayOverlay}
      {...otherProps}
      visible={visible}
      onChange={_onChange}
    /> : <List
      displayOverlay={displayOverlay}
      displayStyle={displayStyle}
      {...otherProps}
      visible={visible}
      onChange={_onChange}
    />}
    visible={visible}
    getPopupContainer={triggerNode => triggerNode.parentElement || document.body}
    onVisibleChange={_visible => setVisible(_visible)}
    placement={placement}
  >
    <span style={style} className={classNames('report-cascade-label', className, { active: onlyValue ? otherProps.value : (otherProps.value?.[0] || otherProps.value?.[1] || otherProps.value?.[2]) })}>
      {onlyValue ? <DisplayOnlyValue {...otherProps} visible={visible} /> : <Display {...otherProps} visible={visible} />}</span>
  </Dropdown>
}
const List = (props) => {
  const { options = [], value = [], onChange, visible, displayStyle, displayOverlay, unselectableFirst, noneText = '不限', allowClear = true } = props
  const [levels, setLevels] = useState(value)
  useEffect(() => {
    setLevels(value)
  }, [visible])
  return <div className="report-cascade" style={displayStyle}>
    {displayOverlay === 'left' && levels?.map((level, index) => {
      const o = findItemByValue(level, options)?.children
      if (!o?.length) return null
      return <ul className="report-cascade-menu">
        {o.map(item => <li
          className={classNames('report-cascade-item', { active: value?.includes(item.value) || levels?.includes(item.value) })}
          onClick={() => {
            onChange?.([...levels.slice(0, index + 1), item.value])
          }}
          onMouseEnter={() => setLevels(pre => [...pre.slice(0, index + 1), item.value])}
        >
          <div className="report-cascade-menu-active">
            {item.label}
          </div>
          {
              !!item?.children?.length && <div>
                <Icon type="m-Vxing_you" />
              </div>
            }
        </li>)}
      </ul>
    }).reverse()}
    <ul className="report-cascade-menu">
      {allowClear && <li
        onMouseEnter={() => setLevels([])}
        className={classNames('report-cascade-item', { activeNone: !value?.length })}
        onClick={() => {
          if (!unselectableFirst) {
            onChange?.([])
          }
        }}
      >
        {noneText}
      </li>}

      {options.map(item => <li
        className={classNames('report-cascade-item', { active: value?.includes(item.value) || levels?.includes(item.value) })}
        onClick={() => {
          if (!unselectableFirst) {
            onChange?.([item.value])
          }
        }}
        onMouseEnter={() => setLevels([item.value])}
      >
        <div className="report-cascade-menu-active">
          {item.label}
        </div>
        {
              !!item?.children?.length && <div>
                <Icon type="m-Vxing_you" />
              </div>
            }
      </li>)}
    </ul>

    {!displayOverlay && levels?.map((level, index) => {
      const o = findItemByValue(level, options)?.children
      if (!o?.length) return null
      return <ul className="report-cascade-menu">
        {o.map(item => <li
          className={classNames('report-cascade-item', { active: value?.includes(item.value) || levels?.includes(item.value) })}
          onClick={() => {
            onChange?.([...levels.slice(0, index + 1), item.value])
          }}
          onMouseEnter={() => setLevels(pre => [...pre.slice(0, index + 1), item.value])}
        > <div className="report-cascade-menu-active">
          {item.label}
        </div>
          {
              !!item?.children?.length && <div>
                <Icon type="m-Vxing_you" />
              </div>
            }
        </li>)}
      </ul>
    })}
  </div>
}

const Display = (props) => {
  const { value = [], options = [], placeholder = '请选择', visible, iconStyle } = props
  const getText = (item) => {
    let text = item.label
    if (item?.parent) {
      const t = getText(item.parent)
      text = `${t}-${text}`
    }
    return text
  }
  const text = () => {
    const item = findItemByValue(value?.slice(-1)[0], options)
    if (!item) return undefined
    return getText(item)
  }
  return <span className={classNames('report-cascade-display', { visible })}>
    <span className={classNames('report-cascade-display-value', { placeholder: value.length === 0 })}>{text() || placeholder}</span>
    <div>
      <Icon
        type="m-Vxing_xia"
        style={{ transition: 'transform 0.3s ease 0.1s', transform: `${visible ? 'rotate(180deg)' : 'rotate(0deg)'}`, ...iconStyle }}
      />
    </div>
  </span>
}

const findItemByValue = (value, options = []) => {
  const item = options.find(m => m?.value === value)
  if (item) return item
  for (const _item of options) {
    const sonItem = findItemByValue(value, _item.children)
    if (sonItem) return sonItem
  }
}

const ListOnlyValue = (props) => {
  const { options = [], value, onChange, visible, displayStyle, unselectableFirst, noneText = '不限', allowClear = true } = props
  const [levels, setLevels] = useState([])

  useEffect(() => {
    setLevels(!value ? [] : getLevels(findItemByValue(value, options)))
  }, [visible])

  return <div className="report-cascade" style={displayStyle}>
    <ul className="report-cascade-menu">
      {allowClear && <li
        className={classNames('report-cascade-item', { activeNone: !value })}
        onClick={() => {
          onChange?.('')
        }}
        onMouseEnter={() => setLevels([])}
      >
        {noneText}
      </li>}
      {options.map(item => <li
        className={classNames('report-cascade-item', { active: value === item.value || levels?.includes(item.value) })}
        onClick={() => {
          if (!unselectableFirst) {
            onChange?.(item.value)
          }
        }}
        onMouseEnter={() => setLevels([item.value])}
      >
        <div className="report-cascade-menu-active">
          {item.label}
        </div>
        {
              !!item?.children?.length && <div>
                <Icon type="m-Vxing_you" />
              </div>
            }
      </li>)}
    </ul>

    {levels?.map((level, index) => {
      // const o = findItemByValue(level, options).children
      const o = findItemByValue(level, index ? options.map(m => m.children).flat() : options)?.children // 一级和二级value重名的硬编码
      if (!o?.length) return null
      return <ul className="report-cascade-menu">
        {o.map(item => <li
          className={classNames('report-cascade-item', { active: value === item.value || levels?.includes(item.value) })}
          onClick={() => {
            onChange?.(item.value)
          }}
          onMouseEnter={() => setLevels(pre => [...pre.slice(0, index + 1), item.value])}
        >
          <div className="report-cascade-menu-active">
            {item.label}
          </div>
          {
              !!item?.children?.length && <div>
                <Icon type="m-Vxing_you" />
              </div>
            }
        </li>)}
      </ul>
    })}
  </div>
}

const DisplayOnlyValue = (props) => {
  const { value = null, options = [], placeholder = '请选择', visible, iconStyle, } = props
  const getText = (item) => {
    let text = item.label
    if (item?.parent) {
      const t = getText(item.parent)
      text = `${t}-${text}`
    }
    return text
  }
  const text = () => {
    const item = findItemByValue(value, options)
    if (!item) return undefined
    return getText(item)
  }
  return <span className={classNames('report-cascade-display', { visible })}>
    <span className={classNames('report-cascade-display-value', { placeholder: value === null })}>{text() || placeholder}</span>
    <div>
      <Icon
        type="m-Vxing_xia"
        style={{ transition: 'transform 0.3s ease 0.1s', transform: `${visible ? 'rotate(180deg)' : 'rotate(0deg)'}`, ...iconStyle }}
      />
    </div>
  </span>
}

const getLevels = (item) => {
  const levels = []
  if (item?.parent) {
    levels.unshift(item.parent.value)
    const l = getLevels(item.parent)
    if (l.length) {
      levels.unshift(...l)
    }
  }
  return levels
}
